export const CMS_DEFAULT_IMAGE = 'https://s3-ap-southeast-1.amazonaws.com/cms.alpha.incart/assets/image-placeholder.png'



// WEBPACK FOOTER //
// ./src/helpers/constants.js